import React from 'react';
import AdminLeadStatus from '../../admin/components/LeadStatus';

export default function AgentLeadStatus() {
  return <AdminLeadStatus isAgent={true} />;
}
